import * as React from "react";
import { clsx } from "clsx";
import { Icon } from "../icon/icon/icon.mjs";
import { useLabels } from "../helpers/label-provider/use-labels.mjs";
const CloseButton = (props) => {
  const labels = useLabels();
  const { className, label, onClick, icon = "#close", attributes, theme, type, ...rest } = props;
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      className: clsx(
        "close-button",
        {
          ["close-button--type-".concat(type)]: !!type
        },
        className
      ),
      onClick,
      type: "button",
      ...attributes,
      ...rest,
      "data-theme": theme
    },
    /* @__PURE__ */ React.createElement("span", { className: "close-button__inner" }, /* @__PURE__ */ React.createElement(Icon, { modifiers: icon, className: "close-button__icon" }), /* @__PURE__ */ React.createElement("span", { className: "sr-only" }, label != null ? label : labels.get("close")))
  );
};
export {
  CloseButton
};
